import * as React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import { useCallback } from 'react';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import gtm from '@/utils/gtm';
import getLocal from 'eco-design-reliance/getLocal';
import AnimatedSection, { AnimatedGrid } from '../../components/AnimatedSection';

const OnePicture: React.FC = () => {
    const { t } = useLang('OnePicture');
    const PRODUCT_IMAGE_URL_HAVE = 'https://websiteoss.ecoflow.com/figma-uploads/1758770924787-zmy0hl-compressed-11111%201.jpg';
    const { locale = 'us' } = getLocal();
    let items = [
        {
            title: t('title1'),
            desc: t('desc1'),
            pc: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855073421/ukpc-1.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854737246/eu-1.jpg',
            pad: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855073421/ukpc-1.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854737246/eu-1.jpg',
            h5: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855155194/ukm-1.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854847173/eum-1.jpg',
            href: '#Output',
        },
        {
            title: t.rich('title2', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc2'),
            pc: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855074654/ukpc-2.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854737335/eu-2.jpg',
            pad: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855074654/ukpc-2.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854737335/eu-2.jpg',
            h5: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855155574/ukm-2.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854847943/eum-2.jpg',

            href: '#SectionImageText',
        },
        {
            title: t.rich('title3', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc3'),
            pc: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855073571/ukpc-3.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854737556/eu-3.jpg',
            pad: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855073571/ukpc-3.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854737556/eu-3.jpg',
            h5: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855155382/ukm-3.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854847341/eum-3.jpg',

            href: '#CompactAndPortable',
        },
        {
            title: t.rich('title4', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc4'),
            pc: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855074437/ukpc-4.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854737741/eu-4.jpg',
            pad: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855074437/ukpc-4.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854737741/eu-4.jpg',
            h5: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855156168/ukm-4.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854848367/eum-4.jpg',
            href: '#SectionImageText2',

        },
        {
            title: t.rich('title5', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc5'),
            pc: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855074174/ukpc-5.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854737962/eu-5.jpg',
            pad: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855074174/ukpc-5.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854737962/eu-5.jpg',
            h5: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855155969/ukm-5.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854848168/eum-5.jpg',

            // href: '#SectionImageText2',
        },
        {
            title: t.rich('title6', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc6'),
            pc: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855073978/ukpc-6.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854738205/eu-6.jpg',
            pad: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855073978/ukpc-6.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854738205/eu-6.jpg',
            h5: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855155786/ukm-6.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854847745/eum-6.jpg',
            href: '#LFP',

        },
        {
            title: t('title7'),
            desc: t('desc7'),
            pc: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855073773/ukpc-7.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854738371/eu-7.jpg',
            pad: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855073773/ukpc-7.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854738371/eu-7.jpg',
            h5: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774855156350/ukm-7.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774854847548/eum-7.jpg',
            href: '#Built',
        },
    ];

    const { isPad, isH5 } = useDeviceDetect();
    React.useEffect(() => {
        const imgHave = new Image();
        imgHave.crossOrigin = 'anonymous';
        imgHave.onload = () => {
            /* 预加载完成 */
        };
        imgHave.onerror = () => {
            /* 预加载失败 */
        };
        imgHave.src = PRODUCT_IMAGE_URL_HAVE;

        if (isPad || isH5) {
            const onePictureElm = document.getElementById('OnePicture');
            if (onePictureElm) onePictureElm.style.opacity = '1';
            return;
        }

        // 监听VideoFrame组件的进度事件
        const handleVideoProgress95 = (data: { progress: number }) => {
            console.log('OnePicture收到VideoFrame进度事件:', data.progress);
            setHaveProductImage(true);
        };

        EcoDesignEventsBus.on('videoProgress95', handleVideoProgress95);

        // 清理事件监听器
        return () => {
            EcoDesignEventsBus.off('videoProgress95', handleVideoProgress95);
        };
    }, [isPad, isH5]);

    const [haveProductImage, setHaveProductImage] = React.useState(false);

    const handleScrollInToView = useCallback((href: string) => {
        if (!href) return;

        const elementId = href.replace('#', '');
        const element = document.getElementById(elementId);

        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            const targetIdx = items.findIndex((item) => item.href === href);
            gtm.push({
                __btn_id1: `${styles.OnePicture} .item-${targetIdx + 1}`,
                __btn_id2: 'animated-section',
                __btn_type: 'common',
            });
        } else {
            console.warn(`Element with id "${elementId}" not found`);
        }
    }, []);

    return (
        <div className={`${styles.OnePictureEu} d3m-layout range1`} id="OnePicture">
            <AnimatedSection
                variant="rotateIn"
                options={{ delay: 200 }}
                data-btn-id="animated-section"
                onClick={() => {
                    handleScrollInToView(items[0].href || '');
                }}
                className="item item-1"
            >
                {!haveProductImage && <EcoImg key={1} pc={items[0].pc} pad={items[0].pad} h5={items[0].h5} isOpenLazy={true} />}
                {haveProductImage && <EcoImg key={2} pc={PRODUCT_IMAGE_URL_HAVE} pad={items[0].pad} h5={items[0].h5} isOpenLazy={true} />}
                {/* <EcoImg pc={items[0].pc} pad={items[0].pad} h5={items[0].h5} /> */}
                <div className="text-wrapper">
                    <div className="title">{items[0].title}</div>
                    <div className="desc">{items[0].desc}</div>
                </div>
                <span className="item-link"></span>
            </AnimatedSection>

            {!isH5 && (
                <div className="item-2">
                    <AnimatedSection
                        variant="rotateIn"
                        options={{ delay: 200 }}
                        onClick={() => {
                            handleScrollInToView(items[1].href || '');
                        }}
                        className="item item-2-1"
                    >
                        <EcoImg pc={items[1].pc} pad={items[1].pad} h5={items[1].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[1].title}</div>
                            <div className="desc">{items[1].desc}</div>
                        </div>
                        <span className="item-link"></span>
                    </AnimatedSection>
                    <AnimatedSection variant="rotateIn" options={{ delay: 200 }} className="item-2-2">
                        <div
                            className="item item-2-2-1"
                            onClick={() => {
                                handleScrollInToView(items[2].href || '');
                            }}
                        >
                            <EcoImg pc={items[2].pc} pad={items[2].pad} h5={items[2].h5} isOpenLazy={true} />
                            <div className="text-wrapper">
                                <div className="title">{items[2].title}</div>
                                <div className="desc">{items[2].desc}</div>
                            </div>
                            <span className="item-link"></span>
                        </div>
                        <div
                            className="item item-2-2-2"
                            onClick={() => {
                                handleScrollInToView(items[3].href || '');
                            }}
                        >
                            <EcoImg pc={items[3].pc} pad={items[3].pad} h5={items[3].h5} isOpenLazy={true} />
                            <div className="text-wrapper">
                                <div className="title">{items[3].title}</div>
                                <div className="desc">{items[3].desc}</div>
                            </div>
                            <span className="item-link"></span>
                        </div>
                    </AnimatedSection>
                </div>
            )}
            {isH5 && (
                <>
                    {/* H5 第一行：item2 + item3 并排 */}
                    <div className="item-2-h5-row1">
                        <AnimatedSection
                            variant="rotateIn"
                            options={{ delay: 200 }}
                            onClick={() => handleScrollInToView(items[1].href || '')}
                            className="item item-2-h5-a"
                        >
                            <EcoImg pc={items[1].pc} pad={items[1].pad} h5={items[1].h5} isOpenLazy={true} />
                            <div className="text-wrapper">
                                <div className="title">{items[1].title}</div>
                                <div className="desc">{items[1].desc}</div>
                            </div>
                            <span className="item-link"></span>
                        </AnimatedSection>
                        <AnimatedSection
                            variant="rotateIn"
                            options={{ delay: 200 }}
                            onClick={() => handleScrollInToView(items[2].href || '')}
                            className="item item-2-h5-b"
                        >
                            <EcoImg pc={items[2].pc} pad={items[2].pad} h5={items[2].h5} isOpenLazy={true} />
                            <div className="text-wrapper">
                                <div className="title">{items[2].title}</div>
                                <div className="desc">{items[2].desc}</div>
                            </div>
                            <span className="item-link"></span>
                        </AnimatedSection>
                    </div>
                    {/* H5 第二行：item4 全宽 */}
                    <AnimatedSection
                        variant="rotateIn"
                        options={{ delay: 200 }}
                        onClick={() => handleScrollInToView(items[3].href || '')}
                        className="item item-2-h5-c"
                    >
                        <EcoImg pc={items[3].pc} pad={items[3].pad} h5={items[3].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[3].title}</div>
                            <div className="desc">{items[3].desc}</div>
                        </div>
                        <span className="item-link"></span>
                    </AnimatedSection>
                </>
            )}
            <div className="item-3">
                <AnimatedGrid variant="rotateIn" options={{ delay: 100, stagger: 0.2 }} className="item-3-1">
                    <div className="item item-3-1-1">
                        <EcoImg pc={items[4].pc} pad={items[4].pad} h5={items[4].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[4].title}</div>
                            <div className="desc">{items[4].desc}</div>
                        </div>
                    </div>
                    <div
                        className="item item-3-1-2"
                        onClick={() => {
                            handleScrollInToView(items[5].href || '');
                        }}
                    >
                        <EcoImg pc={items[5].pc} pad={items[5].pad} h5={items[5].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[5].title}</div>
                            <div className="desc">{items[5].desc}</div>
                        </div>
                        <span className="item-link"></span>
                    </div>
                </AnimatedGrid>
                <AnimatedSection
                    variant="rotateIn"
                    options={{ delay: 100 }}
                    className={'item item-3-2'}
                    onClick={() => handleScrollInToView(items[6].href || '')}
                >
                    <EcoImg pc={items[6].pc} pad={items[6].pad} h5={items[6].h5} isOpenLazy={true} />
                    <div className="text-wrapper">
                        <div className="title">{items[6].title}</div>
                        <div className="desc">{items[6].desc}</div>
                    </div>
                    <span className="item-link"></span>
                </AnimatedSection>
            </div>
        </div>
    );
};

export default OnePicture;
